import React from "react";
import BiographyEdit from "../../../pageparts/biographyEdit";
import { useParams } from "react-router-dom";

export default function DashboardEditArtistProfilePage() {

    const {id} = useParams<{id: string}>();

    const artistId = id ? parseInt(id) : -1;

    return <div className="page">
        <BiographyEdit biographyId={artistId}/>
    </div>;
}